import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.organizationalBenefits],
        config: {
            headerName: getLocalizedString("benefitType"),
            field: 'typeBenefitString',
            filter: "agSetColumnFilter",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.organizationalBenefits],
        config: {
            headerName: getLocalizedString("activeBenefit"),
            field: 'typeBenefitActive',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.organizationalBenefits],
        config: {
            headerName: getLocalizedString("benefitTypeImage"),
            field: 'typeBenefitImage',
            filter: "agSetColumnFilter",
            cellRenderer: "ImageRenderer",
        }
    },
    {
        pages: [paths.organizationalBenefits],
        config: {
            headerName: getLocalizedString("fType"),
            field: 'typeFuncString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.organizationalBenefits],
        config: {
            headerName: getLocalizedString("position"),
            field: 'positionString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.organizationalBenefits],
        config: {
            headerName: getLocalizedString("function"),
            field: 'functionString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.organizationalBenefits],
        config: {
            headerName: getLocalizedString("laborUnion"),
            field: 'laborUnionString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.organizationalBenefits],
        config: {
            headerName: getLocalizedString("category"),
            field: 'categoryString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.organizationalBenefits],
        config: {
            headerName: getLocalizedString("specialty"),
            field: 'specialityString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.organizationalBenefits],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: 'workPlaceString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.organizationalBenefits],
        config: {
            headerName: getLocalizedString("management"),
            field: 'managementString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.organizationalBenefits],
        config: {
            headerName: getLocalizedString("filterObra o Faena"),
            field: 'workOrTaskString',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.organizationalBenefits],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: 'costCenterString',
            filter: "agSetColumnFilter",
        }
    },
]